module.exports = __webpack_public_path__ + "static/img/brees-2010-slide-6.05fe3b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-slide-6.jpg
// module id = Q4P6
// module chunks = 1